<script lang="ts" module>
  import { KIND, SIZE } from "@/libs/ui/Button"

  export { KIND, SIZE }
</script>

<script lang="ts">
  import { Button } from "@/libs/ui/Button"
  import type { ComponentProps } from "svelte"

  let {
    accept = "image/*",
    onUpload,
    onClick,
    children,
    ...props
  }: {
    accept?: string
    onUpload: (file: File) => void
    onClick?: () => void
  } & Omit<ComponentProps<typeof Button>, "as" | "type"> = $props()

  const handleInputClick = () => {
    // For analytics purposes, we need to fire the onClick event when the file dialog actually opens
    onClick?.()
  }

  const onFileUpload = ({ currentTarget }: { currentTarget: HTMLInputElement }) => {
    const file = currentTarget.files?.[0]

    if (file) onUpload(file)

    currentTarget.value = "" // reset the input value to allow uploading the same file again, https://stackoverflow.com/a/60886920
  }
</script>

<Button as="label" {...props} type="button">
  {@render children?.()}
  <input
    class="absolute hidden"
    type="file"
    {accept}
    onclick={handleInputClick}
    oninput={onFileUpload}
    disabled={props.disabled}
  />
</Button>
